<template>
  <div class="voice-room-list">
    <el-collapse accordion v-model="activeNames" @change="handlChange">
      <el-collapse-item name="1">
        <template slot="title">
          <img
            class="title-icon"
            src="../images/party-dark.png"
            alt=""
            srcset=""
            v-if="$route.meta && $route.meta.darkMode"
          />
          <img
            class="title-icon"
            src="../images/party.png"
            alt=""
            srcset=""
            v-else
          />{{$t('components_voiceroom_component_voice_room_list_54')}}</template>
        <div
          class="nav-item"
          v-for="item in voiceRoomList"
          :key="item.id"
          @click="toVoiceRoom(item.roomUid)"
        >
          <div class="image">
            <img :src="item.coverImgUrl + '?d=100x100'" />
          </div>
          <div class="name">{{ item.name }}</div>
        </div>
        <!-- <div class="nav-item" @click="toVoiceRoom('20230922001')">
          <div class="image">
            <img
              src="https://resource.3uplay.com/newicon/tab_1_c.webp?d=300x300"
            />
          </div>
          <div class="name">2023092200位哦是粉红色的理发师的雷锋精神的</div>
        </div>
        <div class="nav-item" @click="toVoiceRoom('20231012004')">
          <div class="image">
            <img
              src="https://resource.3uplay.com/newicon/tab_6_c.webp?d=300x300"
            />
          </div>
          <div class="name">20231012004</div>
        </div> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VoiceRoomList',
  props: {},
  data() {
    return {
      refreshNumber: 0,
      pageIndex: 0,
      pageSize: 30,
      voiceRoomList: [],
      loading: false,
      isWhiteUser: false,
      activeNames: ['1']
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo', 'aliasList']),
    uuid() {
      return this.userInfo.uuid ? this.userInfo.uuid : '';
    }
    // isWhiteUser() {
    //   const isProduction = process.env.VUE_APP_ENV === 'production';
    //   if (isProduction) {
    //     return [
    //       //内部用户测试名单
    //       '3785061',
    //       '3783920',
    //       '3762573',
    //       '3698758',
    //       '3597595',
    //       '3826053',
    //       '250226',
    //       '4071691',
    //       '1054918',
    //       //陪玩师名单
    //       '2266452',
    //       '1920173',
    //       '157263',
    //       '1997854',
    //       '2546931'
    //     ].includes(this.uuid);
    //   } else {
    //     return true;
    //   }
    // }
  },
  created() {
    this.getVoiceRoomList();
    if (!this.aliasList) {
      this.$store.dispatch('app/setAliasList');
    }
    // this.getWhiteList();
  },
  methods: {
    handlChange($event) {
      if ($event == 1) {
        this.getVoiceRoomList();
      }
    },
    async getVoiceRoomList() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const { data } = await this.$http.post('/voiceRoom/outside/list', {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        });
        if (data) {
          this.voiceRoomList = data.content || [];
        }
        return this.voiceRoomList;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        setTimeout(() => {
          this.getVoiceRoomList();
        }, 60000);
      }
    },
    async getWhiteList() {
      try {
        const { data } = await this.$http.get('/user/getUserWhiteIsExist', {
          type: 101
        });
        this.isWhiteUser = data;
      } catch (error) {
        this.isWhiteUser = false;
      }
    },
    toVoiceRoom(roomUid) {
      let roomId = roomUid;
      if (this.aliasList) {
        const aliasItem = this.aliasList.find(item => {
          return item.userUuid === roomUid;
        });
        if (aliasItem) {
          roomId = aliasItem.alias;
        }
      }
      window.open(`/voice-room/${roomId}`, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.title-icon {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}
.nav-item {
  @include flex(flex-start);
  position: relative;
  height: 56px;
  padding: 0 10px 0 24px;
  color: $color-gray-1;
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  &:hover {
    background: rgba($color: $color-split, $alpha: 0.4);
  }
  &.router-link-active {
    background: rgba($color: $color-split, $alpha: 0.7);
  }
  .icon {
    margin: 0 20px 0 8px;
  }
  .image {
    flex-shrink: 0;
    position: relative;
    width: 32px;
    height: 32px;
    margin-left: 5px;
    img {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 4px;
      object-fit: cover;
    }
  }
  .recent-tag {
    position: absolute;
    bottom: -14px;
    left: 50%;
    height: 28px;
    width: 88px;
    transform: translate(-50%, 0) scale(0.5);
    text-align: center;
    line-height: 28px;
    color: #ffffff;
    background: #8c94aa;
    border-radius: 2px;
  }
  .name {
    display: inline-block;
    width: 1px;
    flex: auto;
    margin-left: 15px;
    white-space: nowrap;
    color: #222c43;
    @include ellipsis;
  }
  .online-status {
    position: absolute;
    z-index: 10;
    right: -1px;
    bottom: 0;
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
    border-radius: 100%;
    background: $color-green;
  }
}
.split {
  height: 1px;
  background-color: $color-button;
  margin: 12px 0 0;
}
.title {
  @include flex(space-between);
  padding: 24px 0 6px 24px;
  line-height: 24px;
  color: $color-gray-3;
  font-size: 14px;
  font-weight: 500;
  .handle {
    width: 24px;
    height: 24px;
    margin-right: 24px;
    opacity: 0.4;
    .more {
      @include flex;
      width: 100%;
      height: 100%;
      color: $color-gray-3;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        opacity: 1;
        background: rgba($color: #e8eaee, $alpha: 0.7);
      }
    }
  }
  &:hover {
    .handle {
      opacity: 1;
      .more {
        opacity: 0.6;
      }
    }
  }
}
</style>
<style lang="scss">
.dark {
  .voice-room-list {
    .el-collapse-item {
      > div {
        &:first-child {
          &:hover {
            background: rgba(232, 234, 238, 0.1);
          }
        }
      }
    }
    .el-collapse-item__header {
      color: #8c94aa;
      font-weight: 400 !important;
    }
    .el-collapse-item__header.focusing:focus:not(:hover) {
      color: #8c94aa;
    }
    .nav-item {
      color: #8c94aa;
      .name {
        color: #8c94aa;
      }
      &:hover {
        background: rgba(232, 234, 238, 0.1);
      }
    }
  }
}
.voice-room-list {
  .el-collapse {
    border: none;
  }
  .el-collapse-item {
    > div {
      &:first-child {
        &:hover {
          background: rgba(232, 234, 238, 0.4);
        }
      }
    }
  }
  .el-collapse-item__header {
    background: none;
    padding: 0 84px 0 32px;
    border: none;
    height: 56px;
    line-height: 56px;
    color: #222c43;
    font-size: 14px;
    font-weight: 400 !important;
  }
  .el-collapse-item__header.focusing:focus:not(:hover) {
  }
  .el-icon-arrow-right:before {
    content: '\e790' !important;
  }
  .el-collapse-item__arrow.is-active {
    transform: rotate(-179deg) !important;
  }

  .el-collapse-item__wrap {
    border-bottom: none;
    background: none;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
}
</style>
